export default "__VITE_ASSET__BZvlLT5a__"